// extracted by mini-css-extract-plugin
export var legendIndicator = "_g5-1";
export var legendRight = "_g5-0";